import { render, staticRenderFns } from "./TarefasAprovacaoSolicitanteModal.vue?vue&type=template&id=7de32e94"
import script from "./TarefasAprovacaoSolicitanteModal.vue?vue&type=script&lang=js"
export * from "./TarefasAprovacaoSolicitanteModal.vue?vue&type=script&lang=js"
import style0 from "./TarefasAprovacaoSolicitanteModal.vue?vue&type=style&index=0&id=7de32e94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports